import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  button: {
    paddingLeft: 10,
    paddingRight: 10,
  },
})
export default styles
